import React from 'react';
import { SiteSection, SiteSectionHeader } from '../../components/site';
import type { SolutionPremiumSections } from './types';
import { useTabPanel } from './useTabPanel';

export const SolutionPillarExplorer: React.FC<{
  pillars: SolutionPremiumSections['pillars'];
}> = ({ pillars }) => {
  const { active, getPanelProps, getTabProps } = useTabPanel(pillars.items);

  return (
    <SiteSection id="pillars" tone="muted" className="solution-pillars solution-pillars--showcase">
      <SiteSectionHeader
        eyebrow={pillars.eyebrow}
        title={pillars.title}
        subtitle={pillars.subtitle}
        align="center"
      />
      <div className="solution-pillars__layout">
        <div className="solution-pillars__nav" role="tablist" aria-label="Platform pillars">
          {pillars.items.map((pillar) => {
            const selected = pillar.id === active.id;
            return (
              <button
                key={pillar.id}
                type="button"
                className={`solution-pillars__nav-btn${selected ? ' solution-pillars__nav-btn--active' : ''}`}
                {...getTabProps(pillar, selected)}
              >
                {pillar.label}
              </button>
            );
          })}
        </div>
        {pillars.items.map((pillar) => (
          <div
            key={pillar.id}
            className={`solution-pillars__panel${pillar.id === active.id ? ' solution-pillars__panel--active' : ''}`}
            {...getPanelProps(pillar)}
          >
            <div className="solution-pillars__panel-grid solution-pillars__panel-grid--showcase">
              <div className="solution-pillars__visual solution-pillars__visual--showcase">
                <img
                  src={pillar.image.src}
                  alt={pillar.image.alt}
                  width={pillar.image.width}
                  height={pillar.image.height}
                  loading="lazy"
                />
              </div>
              <div className="solution-pillars__content">
                <div className="solution-pillars__pill" aria-hidden>
                  {pillar.label}
                </div>
                <h3 className="solution-pillars__panel-title">{pillar.title}</h3>
                <ul className="solution-pillars__items">
                  {pillar.items.map((item) => (
                    <li key={item.title} className="solution-pillars__item">
                      <h4>
                        <span className="solution-pillars__dot" aria-hidden />
                        {item.title}
                      </h4>
                      <p>{item.description}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    </SiteSection>
  );
};
